import { Component, Input } from '@angular/core';
import { TrackingInfo } from '@evermile/customer-tracking';
import CustomerTrackingStatusEnum = TrackingInfo.CustomerTrackingStatusEnum;

@Component({
  selector: 'common-order-tracking-title',
  templateUrl: './order-tracking-title.component.html',
  styleUrls: ['./order-tracking-title.component.scss'],
})
export class OrderTrackingTitleComponent {
  @Input({ required: true }) pickupCustomerName!: string;
  @Input({ required: true }) isSenderTracking!: boolean;
  @Input() senderName?: string;
  @Input({ required: true }) customerTrackingStatus!: CustomerTrackingStatusEnum;
  @Input() merchantName!: string;
  @Input() backgroundColor!: string;
  @Input() isDelayed!: boolean;
  readonly StatusEnum = CustomerTrackingStatusEnum;
}
